import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Chip } from "@mui/material";
import type { FilterChipProps } from "./FilterChips";

export const AutocompleteFilterChip = ({
  value,
  label,
  useValue = false,
  ...props
}: FilterChipProps<Array<AutocompleteData>>) => {
  const processedLabel = `${label}: ${value?.map((v) => (useValue ? v.value : v.name)).join(", ")}`;
  return <Chip label={processedLabel} {...props} />;
};
